import React from "react"
import {CompositeFilterDescriptor, filterBy, FilterDescriptor} from "@progress/kendo-data-query"
import {ComboBoxChangeEvent, ComboBoxFilterChangeEvent, ListItemProps} from "@progress/kendo-react-dropdowns"
import {Field} from "@progress/kendo-react-form"
import {RootState} from "../../../rootReducer"
import {useAppSelector} from "../../../store"
import BookingMultiColumnComboBox from "../../Shared/multiColumnComboBox"

const BKAxleComboBox = ({
    bookingID,
    testPackageID,
    onChange,
}: {
    bookingID: number
    testPackageID: number | null
    onChange: (ev: ComboBoxChangeEvent) => void
}) => {
    const loadingAxles = useAppSelector((state: RootState) => state.containers.motBooking.gettingAxles)
    const axlesData = useAppSelector((state: RootState) => state.containers.motBooking.axlesData)

    const [filter, setFilter] = React.useState<CompositeFilterDescriptor>()

    const columns = [
        {
            field: "axleName",
            header: "Select Axle",
            width: "200px",
        },
    ]

    const columnItemRender = (li: React.ReactElement<HTMLLIElement>, itemProps: ListItemProps) => {
        const children = columns.map((col, i) => {
            return (
                <span className="k-table-td" style={{width: col.width}} key={i}>
                    {itemProps.dataItem[col.field]}
                </span>
            )
        })
        return React.cloneElement(li, {...li.props}, children)
    }

    const onFilterChange = (event: ComboBoxFilterChangeEvent) => {
        if (event) {
            const filters = [
                {field: "axleName", operator: "contains", value: event.filter.value},
            ] as Array<FilterDescriptor>
            setFilter({logic: "or", filters})
        }
    }
    // const disabled = bookingID === 0 && ((testPackageID !== null && testPackageID > 0) as boolean)

    return (
        <>
            <Field
                // disabled={disabled}
                allowCustom={false}
                name={"axleCode"}
                component={BookingMultiColumnComboBox}
                textField="axleName"
                dataItemKey="axleCode"
                data={filter ? filterBy(axlesData, filter) : axlesData}
                columns={columns}
                label={"Axle"}
                filterable={true}
                loading={loadingAxles}
                itemRender={columnItemRender}
                onFilterChange={onFilterChange}
                onChange={onChange}
            />
        </>
    )
}

export default BKAxleComboBox
